<template>
    <v-row class="mx-1">
        <AddListToSequence v-model="isAddListToSequenceDialogVisible"
                           :selected-list-id="selectedList"
                           @clearSelectedList="clearSelectedList()" />
        <create-list :isNewList="true" v-model="showCreateListDialog"/>
        <EditListPersons v-model="showEditListPersonsDialog"
                         :listPersons="selectedList"
                         @clearSelectedListPersons="selectedList = ''">
        </EditListPersons>

        <DeleteListPersons v-model="showDeleteListPersonsDialog"
                     :list="selectedListForDelete"
                     @updateListsPersons="getListsPersons()"
                     @clearSelectedUser="selectedListForDelete = ''">
        </DeleteListPersons>

        <v-col cols="12" class="text-h6 pt-0 d-flex align-end">
          <v-text-field
              color="kbDarkBlueText"
              v-model="search"
              append-icon="search"
              :placeholder="$t('general.search')"
              single-line
              hide-details
              clearable>
          </v-text-field>

          <v-btn @click="createList()"
                 class="ml-3"
                 color="mainButtons"
                 dark>
            {{ $t('general.createList') }}
          </v-btn>
        </v-col>

        <v-col cols="12" class="text-h6 pb-0">
            <v-data-table :must-sort="false"
                          fixed-header
                          :height="dataTableHeight"
                          :headers="headers"
                          :items="listsPersons"
                          class="elevation-2"
                          :loading="loadingListsPersons"
                          :options.sync="options"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.lists')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalListPersons">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="font-weight-bold text-capitalize">{{ item.name.toLowerCase() }}</td>

                        <td class="text-center text-capitalize">{{ item.type }}</td>

                        <td class="text-center">{{ item.totalUsers }}</td>

                        <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mm a') }}</td>

                        <td>
                          <div class="d-flex justify-center align-center">
                            <v-menu>
                              <template v-slot:activator="{on}">
                                <v-btn color="kbDarkBlueText" text icon v-on="on">
                                  <v-icon>more_vert</v-icon>
                                </v-btn>
                              </template>

                              <v-list color="kbLight">
                                <v-list-item @click="showList(item)">
                                  <v-list-item-action>
                                    <v-icon color="kbDarkBlueText">remove_red_eye</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title
                                    class="kbDarkBlueText--text"
                                  >{{ $t('general.seeList') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showEditListPersons(item)">
                                  <v-list-item-action>
                                    <v-icon color="kbDarkBlueText">edit</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">{{ $t('general.editList') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="showDeleteListPersons(item)">
                                  <v-list-item-action>
                                    <v-icon color="kbDarkBlueText">delete</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">{{ $t('general.deleteList') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item class="kbDarkBlueText--text"
                                             @click="createCampaign(item)">
                                  <v-list-item-action class="mr-4">
                                    <v-icon color="kbDarkBlueText">mail</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">
                                    {{ `${$t('general.create')} ${$t('general.campaign')}` }}
                                  </v-list-item-title>
                                </v-list-item>

                                <v-list-item class="kbDarkBlueText--text"
                                             @click="showAddListToSequenceDialog(item._id)">
                                  <v-list-item-action class="mr-4">
                                    <v-icon color="kbDarkBlueText">mdi-file-tree</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-title class="kbDarkBlueText--text">
                                    {{ $t('general.addListToSequence') }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingListsPersons">
                            {{ `${$t('general.loading')} ${$t('general.peopleLists')}` }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.peopleListsNotCreated') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import CreateList from '@/pages/App/People/dialogs/CreateList'
import DeleteListPersons from '@/pages/App/Communications/ListsPersons/dialogs/DeleteListPersons.vue'
import EditListPersons from '@/pages/App/Communications/ListsPersons/dialogs/EditListPersons.vue'
import AddListToSequence from './dialogs/AddListToSequence'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import TimeZones from '@/mixins/TimeZones'
export default {
  components: {
    AddListToSequence,
    DeleteListPersons,
    EditListPersons,
    CreateList
  },
  computed: {
    ...mapState({
      listsPersons: state => state.listsPersons.listsPersons,
      loadingListsPersons: state => state.listsPersons.loadingListsPersons,
      paginationListsPersons: state => state.listsPersons.paginationListsPersons,
      totalListPersons: state => state.listsPersons.totalListPersons
    }),
    headers () {
      return [
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.listType'), align: 'center', value: 'type' },
        { text: this.$t('general.peopleInTheList'), align: 'center', value: 'totalUsers' },
        { text: this.$t('general.creationDate'), value: 'createdAt' },
        { text: this.$t('general.actions'), align: 'center', sortable: false }
      ]
    },
    search: {
      get () {
        return this.$store.state.listsPersons.searchListsPersons
      },
      set (value) {
        this.$store.commit('SET_SEARCH_LISTS_PERSONS', value)
      }
    }
  },
  data () {
    return {
      isAddListToSequenceDialogVisible: false,
      options: { sortBy: ['createdAt'], sortDesc: [true] },
      selectedList: '',
      selectedListForDelete: '',
      showCreateListDialog: false,
      showEditListPersonsDialog: false,
      showDeleteListPersonsDialog: false
    }
  },
  methods: {
    clearSelectedList () {
      this.selectedList = ''
    },
    createCampaign (list) {
      this.$router.push({
        name: 'New Campaign',
        query: { list: list._id }
      })
    },
    createList () {
      this.showCreateListDialog = true
    },
    getListsPersons () {
      this.$store.commit('SET_PAGINATION_LISTS_PERSONS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getListsPersons')
    },
    showAddListToSequenceDialog (listId) {
      this.selectedList = listId
      this.isAddListToSequenceDialogVisible = true
    },
    showDeleteListPersons (item) {
      this.selectedListForDelete = item._id
      this.showDeleteListPersonsDialog = true
    },
    showEditListPersons (item) {
      this.selectedList = item._id
      this.showEditListPersonsDialog = true
    },
    showList (item) {
      this.$router.push('lists/' + item._id)
    }
  },
  mixins: [ModuleTableHeight, TimeZones],
  watch: {
    options: {
      handler () {
        this.getListsPersons()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getListsPersons()
    }
  }
}
</script>
